import React from "react";
import styles from "./style";
import { Typography } from "@mui/material";
import { Link } from '@alquiler-argentina/aa-componentes'

const Footer = () => {
  return (
    <Typography css={styles.footer}>Al iniciar sesión o crear una cuenta, estás aceptando los <Link target="_blank" underline="always" href="https://www.alquilerargentina.com/terminos-condiciones.html" >Términos y condiciones </Link>.</Typography>
  );
};

export default Footer;
